<template>
  <BaseFormFieldLayout
    :id="id"
    :label="label"
    :note="note"
    :error-message="errorMessage"
    :field-class="fieldClass"
    :label-class="labelClass"
  >
    <ACascader
      :id="id"
      v-model:value="model"
      :options="options"
      :placeholder="placeholder"
      :allow-clear="allowClear"
      show-search
      :class="{ 'is-invalid': errorMessage, 'w-100': !$attrs.class }"
      size="large"
      expand-trigger="hover"
    />
  </BaseFormFieldLayout>
</template>

<script lang="ts" setup>
import { asyncComponentWrapper } from '@/composables/useReloadModal'
import type { CascaderProps } from 'ant-design-vue/es/cascader'

const ACascader = asyncComponentWrapper(() => import('ant-design-vue/es/cascader'))

const model = defineModel<string | string[] | number | number[]>()

withDefaults(
  defineProps<{
    id: string
    options: CascaderProps['options']
    label?: string
    note?: string
    errorMessage?: string
    fieldClass?: string
    labelClass?: string
    allowClear?: boolean
    placeholder?: string
  }>(),
  {
    label: '',
    note: '',
    errorMessage: '',
    fieldClass: '',
    labelClass: '',
    allowClear: true,
    placeholder: '',
  },
)
</script>
